import { PreviewUploadsField as SharedPreviewUploadsField } from '../../../dapp-form/PreviewUploadsField';
import { MediaUploadWithExisting } from '../../MediaUploadWithExisting';
import type { FormState } from '../types';

interface PreviewUploadsFieldProps {
  dappPreviews: FormState['dappPreviews'];
  previewDimensions: { width: number; height: number } | null;
  existingPreviewUrls: (string | null)[];
  resolvedPreviewUrls: (string | null)[];
  onPreviewChange: (index: number, file: File | null) => Promise<void>;
  onRemoveExistingPreview: (index: number) => void;
  onAddPreviewSlot: () => void;
  onRemovePreviewSlot: (index: number) => void;
}

export function PreviewUploadsField({
  dappPreviews,
  previewDimensions,
  existingPreviewUrls,
  resolvedPreviewUrls,
  onPreviewChange,
  onRemoveExistingPreview,
  onAddPreviewSlot,
  onRemovePreviewSlot,
}: PreviewUploadsFieldProps) {
  return (
    <SharedPreviewUploadsField
      dappPreviews={dappPreviews}
      previewDimensions={previewDimensions}
      existingPreviewUrls={existingPreviewUrls}
      onAddPreviewSlot={onAddPreviewSlot}
      onRemovePreviewSlot={onRemovePreviewSlot}
      renderUploadSlot={(index) => (
        <MediaUploadWithExisting
          name={`dappPreview-${index}`}
          value={dappPreviews[index]}
          existingUrl={resolvedPreviewUrls[index]}
          onChange={(file: File | null) => onPreviewChange(index, file)}
          onRemoveExisting={() => onRemoveExistingPreview(index)}
          placeholderClassName="absolute inset-0"
          buttonType="add"
        />
      )}
    />
  );
}
